<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>

    </nav> -->

    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <div class="main-panel" >
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 style="color: black !important;" class="page-title text-primary">ONBOARDING</h2>
                </div>
                <div class="form" [hidden]="isShownWrite">
                    <div class="row" style="height: 5rem;">
                        <div class="col-md-2">
                            <label>Customer Code</label><span style="color: red;">*</span><br />
                            <input type="text" id="customercode" [(ngModel)]="customercode" class="txt-input" />
                        </div>
                        <div class="col-md-3">
                            <label>Customer Name</label><span style="color: red;">*</span><br />
                            <input type="text" id="corporatename" [(ngModel)]="corporatename" class="txt-input" />
                        </div>
                        <div class="col-md-2 grid-margin" style="padding-top: 2%;">
                            <div class="clearfix">
                                <div class="upload-btn-wrapper" style="width: max-content;">
                                    <button class="btnUpload">Upload Logo&nbsp; <img src="../../assets/UploadIcon.png">
                                    </button>
                                    <input type="file" #file (change)="uploadFile(file.files)" id="myfile" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <span [hidden]="isShownimage"><a href="{{myfile}}" target="_blank"><img src="{{myfile}}"
                                        width="150" id="imgfile" style="padding-top:35px;height:75px;" /></a></span>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 1em;">
                        <div class="col-lg-4">
                            <label>Communication Address</label><span style="color: red;">*</span> <br />
                            <input type="text" id="Address1" [(ngModel)]="Address1" placeholder="Address Line 1"
                                class="txt-input" /><br />
                        </div>

                        <div class="col-lg-5">
                            <label>Website</label><span style="color: red;">*</span> <br />
                            <input type="url" id="website" [(ngModel)]="website" class="txt-input" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4" style="padding-top:1em;padding-bottom: 1.5em;">
                            <input type="text" id="Address2" [(ngModel)]="Address2" placeholder="Address Line 2"
                                class="txt-input" /><br />
                        </div>
                    </div>

                    <div class="row" style="width:100%;padding-left: 15px; ">
                        <div class="col-lg-12" style="border: ridge;padding-bottom: 2em;">
                            <div class="col-lg-12" *ngFor="let ad of AddCust">
                                <div class="row" style="padding-top:1em;">
                                    <div class="col-lg-4">
                                        <label>Contact Person Name</label><span style="color: red;">*</span> <br />
                                        <input type="text" id="{{ad.personName}}" class="txt-input" /><br />
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Role</label><span style="color: red;">*</span> <br />
                                        <input type="text" id="{{ad.role}}" class="txt-input" />
                                    </div>
                                    <div class="col-lg-3" style="padding-top: 3rem;" [hidden]="isShownActiveCus">
                                        <input type="checkbox" name="Cstatus" [(ngModel)]="StatusContact">&nbsp;
                                        <label>Set as Inactive</label>
                                    </div>
                                    <div class="col-lg-1" style="padding-top: 3rem;" [hidden]="isShownDeleteBtn">
                                        <img src="../../assets/Delete_Icon.png" (click)="RemoveCust(ad)" />
                                    </div>
                                </div>

                                <div class="row" style="padding-top:1em;">
                                    <div class="col-lg-4">
                                        <label>Phone Number</label> <br />
                                        <input type="number" id="{{ad.phonenumber}}" class="txt-input" /><br />
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Mobile Number</label><span style="color: red;">*</span> <br />
                                        <input type="number" id="{{ad.mobile}}" class="txt-input" />
                                    </div>
                                    <div class="col-lg-4">
                                        <label>Email ID</label><span style="color: red;">*</span> <br />
                                        <!-- <input type="email" id="{{ad.emailid}}" class="txt-input" required pattern="^[^\s@]+@[^\s@]+\.[^\s@]{2,}$" /> -->
                                        <input type="text" class="txt-input" id="{{ad.emailid}}" name="emailid" ngModel
                                            #email="ngModel">
                                        <!--  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" <div *ngIf="email.errors &&(email.touched || email.dirty)" class="aler alert-danger ">
                                            <div [hidden]="!email.errors?.pattern">
                                                Invalid EmailId
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6"></div>
                                <div class="col-lg-4" style="padding-top:1em;">
                                    <button class="bttn-save" (click)="AddOnboard()"
                                        [hidden]="isShownAddBtn">Add</button>
                                    <button class="bttn-save" (click)="SaveOnboadContactPerson()"
                                        [hidden]="isShownSaveContact">Save</button>
                                    <button class="bttn-save" (click)="UpdateOnboadContactPerson()"
                                        [hidden]="isShownUpdateContact">Update</button>
                                    &nbsp;<button class="bttn-save" (click)="ClearOnboadContactPerson()"
                                        [hidden]="isShownClearBtn">Clear</button>
                                </div>
                            </div>

                            <div class="col-sm-12 mat-elevation-z8"
                                style="box-shadow: unset;padding: 0px ; padding-top: 10px;" #TABLE
                                [hidden]="isShownActive">
                                <table mat-table [dataSource]="dataSource1" style="width: 100%;" matSortmat-table
                                    #table1 style="width: 100%;" matSort #Sort1="matSort">
                                    <ng-container matColumnDef="sno">
                                        <th mat-header-cell *matHeaderCellDef
                                            style="color:black !important;background-color: white">
                                            S.NO </th>
                                        <td mat-cell *matCellDef="let item; let j = index">
                                            {{(j +1)  + (Paginator1.pageIndex * Paginator1.pageSize) }}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="contactPersonName">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            style="color: black !important;background-color: white">
                                            Contact Person</th>
                                        <td mat-cell *matCellDef="let element"
                                            (click)="EditOnboardContactPerson(element)" style="cursor: pointer;">
                                            {{element.contactPersonName}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="role">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            style="color: black !important;background-color: white">
                                            Role</th>
                                        <td mat-cell *matCellDef="let element"
                                            (click)="EditOnboardContactPerson(element)" style="cursor: pointer;">
                                            {{element.role}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="emailId">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            style="color: black !important;background-color: white">
                                            EmailId</th>
                                        <td mat-cell *matCellDef="let element"
                                            (click)="EditOnboardContactPerson(element)" style="cursor: pointer;">
                                            {{element.emailId}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="phoneNo">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            style="color: black !important;background-color: white">
                                            Phone No</th>
                                        <td mat-cell *matCellDef="let element"
                                            (click)="EditOnboardContactPerson(element)" style="cursor: pointer;">
                                            {{element.phoneNo}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="mobileNo">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            style="color: black !important;background-color: white">
                                            Mobile No</th>
                                        <td mat-cell *matCellDef="let element"
                                            (click)="EditOnboardContactPerson(element)" style="cursor: pointer;">
                                            {{element.mobileNo}}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="status">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            style="color: black !important;background-color: white">
                                            Status</th>
                                        <td mat-cell *matCellDef="let element"
                                            (click)="EditOnboardContactPerson(element)" style="cursor: pointer;">
                                            {{element.status}}
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns1;">
                                    </tr>
                                </table>
                                <mat-paginator #Paginator1="matPaginator" [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                    showFirstLastButtons></mat-paginator>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-5" style="padding-top:1em;">
                            <label>Description</label> <br />
                            <textarea cols="40" rows="3" id="description" [(ngModel)]="description"
                                class="txt-input"></textarea>
                        </div>
                        <div class="col-lg-2" style="padding-top:4rem;" [hidden]="isShownActive">
                            <input type="checkbox" [(ngModel)]="Status"> Set As Inactive
                        </div>
                        <div class="col-lg-4" style="padding-top: 4rem;">
                            <button class="bttn-save" [hidden]="isShownSaveBtn" (click)="SubmitOnboard()">SAVE</button>
                            &nbsp;&nbsp;
                            <button class="bttn-Update" (click)="UpdateOnboard()"
                                [hidden]="isShownUpdateBtn">Update</button>&nbsp;&nbsp;
                            <button class="bttn-clear" (click)="ClearOnboard()">Clear</button>
                        </div>
                    </div>

                </div>


                <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                    <span style="color: red;">{{ErrorMsg}}</span>
                    <span style="color: green;">{{SuccessMsg}}</span>
                </div>
            </div>



            <div class="content-wrapper">

                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 grid-margin">
                                        <div class="card">
                                            <div class="card-body" style="padding: 0;">
                                                <div class="col-lg-12 form-inline"
                                                    style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                    <div class="col-lg-3"></div>
                                                    <div class="col-lg-9" style="padding-right:0px;">
                                                        <div class="form-group" style="padding-left:55%;">
                                                            <div class="input-group">
                                                                <!-- <label style="padding-right: 25px;">Search</label> -->
                                                                <input type="text" placeholder="Search"
                                                                    [(ngModel)]="searchText"
                                                                    (keyup)="applyFilter($event.target.value)"
                                                                    class="txt-Search"> <i class="fa fa-search fa-2x"
                                                                    style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>
                                                                <!-- <input type="text" class="form-control"
                                                                    placeholder="Search..." aria-label="Search..."
                                                                    aria-describedby="basic-addon2">
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-sm btn-gradient-danger"
                                                                        type="button">Search</button>
                                                                </div> -->
                                                            </div>
                                                            <button type="button" class="btn btn-sm ">
                                                                <img src="../../assets/ExportPDF.png" />
                                                            </button>
                                                            <button type="button" class="btn  btn-sm">
                                                                <img src="../../assets/ExportExcel.png"
                                                                    (click)="exportexcel()" style="cursor: pointer;" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-sm-12 mat-elevation-z8"
                                                    style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                    <table mat-table [dataSource]="dataSource" #table
                                                        style="width: 100%;" matSortmat-table [dataSource]="dataSource"
                                                        #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="color:black !important;background-color: white">
                                                                S.NO </th>
                                                            <td mat-cell *matCellDef="let item; let j = index">
                                                                {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="customercode">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Customer Code</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditOnboard(element)" style="cursor: pointer;">
                                                                {{element.customercode}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="corporatename">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Customer Name</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditOnboard(element)" style="cursor: pointer;">
                                                                {{element.corporatename}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="address1">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Address 1</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditOnboard(element)" style="cursor: pointer;">
                                                                {{element.address1}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="weburl">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Website</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditOnboard(element)" style="cursor: pointer;">
                                                                {{element.weburl}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="status">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Status</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditOnboard(element)" style="cursor: pointer;">
                                                                {{element.status}}
                                                            </td>
                                                        </ng-container>

                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                        showFirstLastButtons></mat-paginator>
                                                </div>



                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4">
                                        <!-- <p class="text-primary" style="float:right"><i>
                                                &nbsp;</i>Page 1,2,3,4<i>&nbsp;></i></p> -->
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- partial:../../partials/_footer.html -->
            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>

                    </span>

                </div>
            </footer>
            <!-- partial -->
        </div>

    </div>
</div>